import { SET_CATEGORY_INFO } from './const';

export function setCategoryInfo(payload: ICategoryState) {
  return {
    type: SET_CATEGORY_INFO,
    payload,
  };
}
